import { createContext, ReactNode, useContext, useState } from 'react';

export type PreSelectedPlan = 'copier' | 'dedi' | 'analytics' | null;

interface UpgradeDrawerContextType {
  isOpen: boolean;
  preSelectedPlan: PreSelectedPlan;
  openUpgradeDrawer: (plan?: PreSelectedPlan) => void;
  closeUpgradeDrawer: () => void;
}

const UpgradeDrawerContext = createContext<UpgradeDrawerContextType | undefined>(undefined);

export const useUpgradeDrawer = () => {
  const context = useContext(UpgradeDrawerContext);
  if (!context) {
    throw new Error('useUpgradeDrawer must be used within an UpgradeDrawerProvider');
  }
  return context;
};

interface UpgradeDrawerProviderProps {
  children: ReactNode;
}

export const UpgradeDrawerProvider = ({ children }: UpgradeDrawerProviderProps) => {
  const [isOpen, setIsOpen] = useState(false);
  const [preSelectedPlan, setPreSelectedPlan] = useState<PreSelectedPlan>(null);

  const openUpgradeDrawer = (plan?: PreSelectedPlan) => {
    setPreSelectedPlan(plan || null);
    setIsOpen(true);
  };
  const closeUpgradeDrawer = () => {
    setIsOpen(false);
    setPreSelectedPlan(null);
  };

  return (
    <UpgradeDrawerContext.Provider value={{ isOpen, preSelectedPlan, openUpgradeDrawer, closeUpgradeDrawer }}>
      {children}
    </UpgradeDrawerContext.Provider>
  );
};

export default UpgradeDrawerContext;
